module.exports = __webpack_public_path__ + "img/diesel.482b6316.svg";